import { render, staticRenderFns } from "./VersionDisplay.vue?vue&type=template&id=97dda0b6&scoped=true&"
import script from "./VersionDisplay.vue?vue&type=script&lang=js&"
export * from "./VersionDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VersionDisplay.vue?vue&type=style&index=0&id=97dda0b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dda0b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
